<div *ngIf="isLoading" class="loading">
    <div class="loading_txt">
        <div class="load_txt">{{"startorderUk.loadinglabel" | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
<div class="modal fade in stockPopUP" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" [ngClass]="{'show': (stockPopup && !isAsmUser)}" id="stockUpdatePopup">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="stockpop_TxtSection">
                    <div class="stockPopHeader" [innerHTML]="stockoutpopdata?.headline"></div>
                    <div class="season_Txt">{{landingapi?.currentInSeason | seasonspilt}} Season Updates: </div>
                    <ul class="availabiltyTxt_UL">
                        <li [innerHTML]="stockoutpopdata?.message1"></li>
                        @if(stockoutpopdata?.message2){
                            <li [innerHTML]="stockoutpopdata?.message2"></li>
                        }
                    </ul>
                    <button class="stockPop_Continue" (click)="closestockpopup()">{{stockoutpopdata?.button}}</button>
                    <div class="need_Help_Section">
                        <div class="Txt1">
                           <div class="needHelp_Txt" [innerHTML]="stockoutpopdata?.message3"></div>
                           <ul class="needHelp_UL">
                            <li class="needHelp_LI1">{{stockoutpopdata?.label1}}</li>
                            <li class="needHelp_LI2">
                                <span (click)="openCalendlyModal()" class="underline_Txt" [innerHTML]="stockoutpopdata?.link"></span>
                                <span [innerHTML]="stockoutpopdata?.label2"></span>
                            </li>
                           </ul>
                        </div>
    
                    </div>
                    <div class="dont-show-again">
                        <label class="checkbox-button">
                            <input type="checkbox" [(ngModel)]="dontShowAgain" class="stockPop_checkob" />
                            <span class="checkbox-button__control stockpop_checkbox-button__control"></span>
                        </label>
                        <label>
                            <span class="checkbox-label stock_Dont_Show_Label" [innerHTML]="stockoutpopdata?.thankYouMessage"></span>
                        </label>
                    </div>
                    <div class="stockPopjbgcode" [innerHTML]="stockoutpopdata?.jobBagCode"></div>
                </div>
                <div class="stock_PopImgsection">
                    <div data-bs-dismiss="modal" class="close_Btn" (click)="closestockpopup()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none">
                            <rect width="24" height="24" fill="white" />
                            <path
                                d="M12 13.4L7.10005 18.3C6.91672 18.4833 6.68338 18.575 6.40005 18.575C6.11672 18.575 5.88338 18.4833 5.70005 18.3C5.51672 18.1167 5.42505 17.8833 5.42505 17.6C5.42505 17.3167 5.51672 17.0833 5.70005 16.9L10.6 12L5.70005 7.1C5.51672 6.91667 5.42505 6.68334 5.42505 6.4C5.42505 6.11667 5.51672 5.88334 5.70005 5.7C5.88338 5.51667 6.11672 5.425 6.40005 5.425C6.68338 5.425 6.91672 5.51667 7.10005 5.7L12 10.6L16.9 5.7C17.0834 5.51667 17.3167 5.425 17.6 5.425C17.8834 5.425 18.1167 5.51667 18.3 5.7C18.4834 5.88334 18.575 6.11667 18.575 6.4C18.575 6.68334 18.4834 6.91667 18.3 7.1L13.4 12L18.3 16.9C18.4834 17.0833 18.575 17.3167 18.575 17.6C18.575 17.8833 18.4834 18.1167 18.3 18.3C18.1167 18.4833 17.8834 18.575 17.6 18.575C17.3167 18.575 17.0834 18.4833 16.9 18.3L12 13.4Z"
                                fill="#2A3237" />
                        </svg>
                    </div>
                    <div>
                        <img class="stockPop_Img" alt="Stock Update" [src]="getMediaImage(stockoutpopdata?.media)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="seasonValue && (enablePage && enablePage.showLocationPage)">
    <div *ngIf="locationData | async as data">
        <section class="col-xs-12 cart_neworder">
            <div class="col-xs-6 cart_neworderheader">New {{seasonValue | seasonspilt}} <ng-container *ngIf="prepreseason==seasonValue;else normaltext">Pre-order</ng-container><ng-template #normaltext>Order</ng-template></div>
        </section>
        <section class="col-xs-12" id="cart_selectlocation-5">
            <div class="cart_selectparent prebookselectlocation" id="cart_selectlocation-1">

                <div class="prebok_selectbox">
                    <div class="col-xs-12  pre_select_box">
                        <div class="col-xs-12 col-md-7 normalorderselect prebook_selectheader">{{"startorderUk.locations.selectloclabel" | cxTranslate}}<div>
                                {{data.text2}}</div>
                        </div>
                        <div class="col-xs-12 col-md-5 prebook_selectcount">{{"startorderUk.locations.orderto" | cxTranslate}}&nbsp;<span
                                class="cart_loccount" *ngIf="searchText.value === ''">{{selection.selected.length}}
                            </span> <span>locations</span></div>
                    </div>
                    <div class="col-xs-12 cart_selectline"></div>
                    <div class="col-xs-12 cart_selectoptions pre_select_box">
                        <div class="cart_customsearch">
                            <i class="global_searchicon"></i><input type="text" #searchText class="backcolor"
                                (keyup)="applyFilter(searchText.value)"
                                placeholder="Search for location" id="cart_searchbox"><button>{{"startorderUk.locations.searchlabel" | cxTranslate}}</button>
                        </div>
                        <div class="cart_selectunselect">
                            <div class="cart_selectoption" id="cart_selectall" (click)="handleOnSelectAllBtnClick()">
                                {{"startorderUk.locations.selectalllabel" | cxTranslate}}</div>
                            <div class="cart_selectdivision"></div>
                            <div class="cart_selectoption" id="cart_clearall" (click)="handleOnClearSelection()">{{"startorderUk.locations.clearseleclabel" | cxTranslate}}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 prebooklocation_header">
                        <span class=" col-xs-4 pb_headtext">{{"startorderUk.locations.title" | cxTranslate}}</span>
                    </div>
                    <div class="tablecontainer">
                        <table mat-table [dataSource]="dataSource">
                            <ng-container matColumnDef="checkbox">
                                <th mat-header-cell *matHeaderCellDef></th>

                                <td mat-cell *matCellDef="let element" [ngClass]="{'disbleRow': element.checked,'disableCheckboxCell': element.checked}">
                                    <ng-container *ngIf="element as row">
                                    <div class="cart_summarycheckbox"><label class="checkbox-button"(click)="inputspanclick(row)"><input
                                                type="checkbox"  class="cartSummary_checkbox" name="checkbox"
                                                [(ngModel)]="element.rowChecked" [disabled]="element.checked" (click)="inputclick(row)"><span
                                                class="checkbox-button__control" ></span></label></div></ng-container>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="locname">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''">
                                    {{ element.locname?.trim().replace(/,+$/, '') }}</td>
                            </ng-container>
                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''">
                                    {{element.address?.trim().replace(/,+$/, '') }} </td>
                            </ng-container>
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef></th>
                               
                                <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''">
                                    {{element.state}} </td>
                            </ng-container>
                            <ng-container matColumnDef="orderPlaced">
                                <th mat-header-cell *matHeaderCellDef></th>

                                <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''">
                                    <span class="myordertext" *ngIf="element.checked">{{data?.content}} <a class="location_link" [routerLink]="'/orders/my-orders'" [queryParams]=" {season: seasonValue}">{{"startorderUk.locations.myorders" | cxTranslate}}</a> {{data?.text1}}</span><span
                                        *ngIf="!element.checked"></span></td>
                            </ng-container>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="!row.checked && handleOnRowClick(row)"
                                [ngClass]="selection.isSelected(row) ? 'selected' : ''"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="no-data-cell">{{"startorderUk.locations.norecordsmsg" | cxTranslate}}</td>
                                  </tr>
                        </table>
                    </div>
                </div>
                <div class="cart_startorderbtnsection">
                    <a class="OM_exitBtn showPopupclick" (click)="handleOnExitClick()" data-toggle="modal" data-target="#OM_exitPopup">Exit</a>
                    <input type="hidden" class="selectLocSeasonValue" id="selectLocSeasonValue-1">
                    <button *ngIf="seasonValue == inseason" type="button" class="cart_startorderbtn"
                        id="preSeasonNew-1" (click)="handleRequestDoseBtnClick()"
                        [disabled]="selection.selected.length == 0">{{"startorderUk.selectproduct" | cxTranslate}}</button>
                    <button *ngIf="seasonValue == preseason || seasonValue==prepreseason" type="button" class="cart_startorderbtn"
                        id="preSeasonNew-1" (click)="handleRequestDoseBtnClick()"
                        [disabled]="selection.selected.length == 0">{{"startorderUk.selectproduct" | cxTranslate}}</button>
                </div>
                <div class="clearboth selectlocationOrderBtn">
                    <div class="view_order locationbottombtn">
                        <a (click)="handleOnOrderLinkClick()" title="View My Current Orders"
                            class="showPopupclick pl-0">{{"startorderUk.viewMyCurrOrder" | cxTranslate}}&nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<div class="stock_commonleaving_abandonedPop modal stockpop_Calendly_PopUp" role="dialog" data-bs-backdrop="static" id="stockpop_Calendly_PopUp">
  <div class="stock_knowledgeHub_abandonedPopContent">
    <div class="stock_knowledgeHub_abandonedPopHeader">
      <div class="stock_knowledgeHub_abandonedPopTitle">{{popupdata?.headline}}</div>
      <div class="stock_knowledgeHub_abandonedPopClose" (click)="closeCalendlyModal()">X</div>
      <div class="clearboth"></div>
    </div>
    <div class="stock_knowledgeHub_abandonedPopText">
      <p [innerHTML]="popupdata?.message1" class="popup_Text1"></p>
      <p [innerHTML]="popupdata?.message2" class="popup_Text1"></p>
    </div>
    <div class="stock_knowledgeHub_abandonedPopBtns">
      <a class="continuecalendly" (click)="openCalendly()"
                            (click)="closeCalendlyModal()">{{popupdata?.label1}}</a>
      <button class="stock_knowledgeHub_abandonedPopBtn cancelBtn"
        (click)="closeCalendlyModal()">{{popupdata?.label2}}</button>
    </div>
    <div class="knowledgedocnumberUk">{{popupdata?.jobBagCode}}</div>
  </div>
</div>